module.exports = __webpack_public_path__ + "media/images/uploadBtnIcon-e284cb3ade8bd4cb75facfe5b88d489e.svg";